/* Floating WhatsApp concierge - site-wide (draft theme) */
(function () {
  function boot() {
    if (document.querySelector(".mana-wa")) return;
    if (!document.body || document.body.dataset.waOff === "true") return;

    var WA_NUMBER = "923114711112";
    var WA_DISPLAY = "0311-4711112";
    var AUTO_KEY = "mana_wa_auto_v2";
    var DELAY_MS = 10000;
    var logoSrc = (window.manaWaLogoUrl && String(window.manaWaLogoUrl)) || "";
    var pageLabel =
      (document.title || "Manna Crockery").replace(/\s+[-|-].*$/, "").trim() || "the site";

    var icon =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';

    var avatarHtml = logoSrc
      ? '<img src="' + logoSrc + '" alt="" width="34" height="34" decoding="async">'
      : icon;

    var root = document.createElement("div");
    root.className = "mana-wa";
    root.dataset.manaWa = "";
    root.innerHTML =
      '<div class="mana-wa__panel" role="dialog" aria-label="WhatsApp chat with Manna Crockery" aria-hidden="true" hidden>' +
      '<div class="mana-wa__head">' +
      '<div class="mana-wa__avatar">' +
      avatarHtml +
      '<span class="mana-wa__online" aria-hidden="true"></span>' +
      "</div>" +
      '<div class="mana-wa__head-text">' +
      "<strong>Manna Crockery</strong>" +
      "<span>Online · replies in minutes</span>" +
      "</div>" +
      '<button type="button" class="mana-wa__head-close" data-wa-close aria-label="Close chat"><span class="mana-wa__head-x" aria-hidden="true"></span></button>' +
      "</div>" +
      '<div class="mana-wa__body">' +
      '<p class="mana-wa__meta">Today</p>' +
      '<div class="mana-wa__bubble">Hi - welcome to Manna Crockery.<time>Just now</time></div>' +
      '<div class="mana-wa__bubble">How can we help with your table, tea set, or order today?<time>Just now</time></div>' +
      '<div class="mana-wa__chips" data-wa-chips>' +
      '<button type="button" class="mana-wa__chip" data-wa-msg="Hi Manna Crockery - I need help choosing a product from ' +
      pageLabel +
      '.">Product advice</button>' +
      '<button type="button" class="mana-wa__chip" data-wa-msg="Hi Manna Crockery - I want to check my order status.">Track order</button>' +
      '<button type="button" class="mana-wa__chip" data-wa-msg="Hi Manna Crockery - I’d like to visit a Lahore store (Shah Alam / Ichra / DHA).">Store visit</button>' +
      "</div>" +
      "</div>" +
      '<div class="mana-wa__foot">' +
      '<a class="mana-wa__cta" data-wa-open href="https://wa.me/' +
      WA_NUMBER +
      '" target="_blank" rel="noopener noreferrer">' +
      icon +
      "<span>Chat on WhatsApp</span>" +
      "</a>" +
      '<p class="mana-wa__note">' +
      "<span>" +
      WA_DISPLAY +
      " · Orders &amp; support</span>" +
      '<span class="mana-wa__social" aria-label="Social">' +
      '<a href="https://www.instagram.com/mannacrockeryofficial/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Instagram">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="17.5" cy="6.5" r="1.1" fill="currentColor"/></svg>' +
      "</a>" +
      '<a href="https://www.facebook.com/mannacrockrey/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" title="Facebook">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M14 8h2V5h-2c-2.2 0-4 1.8-4 4v2H8v3h2v7h3v-7h2.2l.8-3H13V9c0-.6.4-1 1-1z"/></svg>' +
      "</a>" +
      '<a href="https://www.tiktok.com/@mannacrockeryofficial" target="_blank" rel="noopener noreferrer" aria-label="TikTok" title="TikTok">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .55.04.81.1v-3.5a6.37 6.37 0 00-.81-.05A6.34 6.34 0 003.15 15.3a6.34 6.34 0 0010.86 4.43V11.7a8.27 8.27 0 004.82 1.54V9.78a4.84 4.84 0 01-.24-.09z"/></svg>' +
      "</a>" +
      "</span>" +
      "</p>" +
      "</div>" +
      "</div>" +
      '<button type="button" class="mana-wa__fab" data-wa-toggle aria-label="Open WhatsApp chat" aria-expanded="false">' +
      '<span class="mana-wa__flash" aria-hidden="true"></span>' +
      '<span class="mana-wa__badge" aria-hidden="true">1</span>' +
      '<span class="mana-wa__fab-icon">' +
      icon +
      "</span>" +
      '<span class="mana-wa__fab-close" aria-hidden="true"></span>' +
      "</button>";

    document.body.appendChild(root);

    var panel = root.querySelector(".mana-wa__panel");
    var toggle = root.querySelector("[data-wa-toggle]");
    var closeBtn = root.querySelector("[data-wa-close]");
    var openLink = root.querySelector("[data-wa-open]");
    var chips = root.querySelectorAll("[data-wa-msg]");
    var autoTimer = null;
    var audioCtx = null;
    var ignoreOutsideUntil = 0;

    function waUrl(text) {
      var base = "https://wa.me/" + WA_NUMBER;
      if (!text) return base;
      return base + "?text=" + encodeURIComponent(text);
    }

    function setOpen(open) {
      root.classList.toggle("is-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? "Close WhatsApp chat" : "Open WhatsApp chat");
      panel.setAttribute("aria-hidden", open ? "false" : "true");
      if (open) {
        panel.removeAttribute("hidden");
        ignoreOutsideUntil = Date.now() + 800;
        try {
          sessionStorage.setItem("mana_wa_seen", "1");
        } catch (_) {}
        var badge = root.querySelector(".mana-wa__badge");
        if (badge) badge.hidden = true;
      } else {
        panel.setAttribute("hidden", "");
      }
    }

    function defaultMessage() {
      return "Hi Manna Crockery - I’m browsing “" + pageLabel + "” and need assistance.";
    }

    openLink.href = waUrl(defaultMessage());

    toggle.addEventListener("click", function () {
      setOpen(!root.classList.contains("is-open"));
    });
    closeBtn.addEventListener("click", function () {
      setOpen(false);
    });

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        var msg = chip.getAttribute("data-wa-msg") || defaultMessage();
        window.open(waUrl(msg), "_blank", "noopener,noreferrer");
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("is-open")) setOpen(false);
    });

    document.addEventListener("click", function (e) {
      if (!root.classList.contains("is-open")) return;
      if (Date.now() < ignoreOutsideUntil) return;
      if (root.contains(e.target)) return;
      setOpen(false);
    });

    function ensureAudioCtx() {
      try {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        if (!audioCtx) audioCtx = new AC();
        return audioCtx;
      } catch (_) {
        return null;
      }
    }

    function unlockAudio() {
      var ctx = ensureAudioCtx();
      if (!ctx) return;
      if (ctx.state === "suspended") {
        try {
          ctx.resume();
        } catch (_) {}
      }
    }

    ["pointerdown", "keydown", "touchstart", "click"].forEach(function (ev) {
      document.addEventListener(ev, unlockAudio, { once: true, passive: true, capture: true });
    });

    function playAppleAlert() {
      try {
        var ctx = ensureAudioCtx();
        if (!ctx) return;
        var run = function () {
          try {
            var t0 = ctx.currentTime + 0.03;
            function tone(freq, start, dur, peak) {
              var o = ctx.createOscillator();
              var g = ctx.createGain();
              var f = ctx.createBiquadFilter();
              o.type = "sine";
              o.frequency.setValueAtTime(freq, start);
              f.type = "lowpass";
              f.frequency.setValueAtTime(4200, start);
              g.gain.setValueAtTime(0.0001, start);
              g.gain.exponentialRampToValueAtTime(peak, start + 0.018);
              g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
              o.connect(f);
              f.connect(g);
              g.connect(ctx.destination);
              o.start(start);
              o.stop(start + dur + 0.04);
            }
            tone(1046.5, t0, 0.38, 0.14);
            tone(2093, t0, 0.22, 0.035);
            tone(1318.5, t0 + 0.15, 0.48, 0.12);
            tone(2637, t0 + 0.15, 0.28, 0.025);
          } catch (_) {}
        };
        if (ctx.state === "suspended") {
          ctx.resume().then(run).catch(function () {});
        } else {
          run();
        }
      } catch (_) {}
    }

    function alreadyAutoOpened() {
      try {
        return sessionStorage.getItem(AUTO_KEY) === "1";
      } catch (_) {
        return false;
      }
    }

    function markAutoOpened() {
      try {
        sessionStorage.setItem(AUTO_KEY, "1");
        sessionStorage.setItem("mana_wa_seen", "1");
      } catch (_) {}
    }

    try {
      if (sessionStorage.getItem("mana_wa_seen")) {
        var badgeSeen = root.querySelector(".mana-wa__badge");
        if (badgeSeen) badgeSeen.hidden = true;
      }
    } catch (_) {}

    function autoOpenChat() {
      if (alreadyAutoOpened()) return;
      if (root.classList.contains("is-open")) {
        markAutoOpened();
        return;
      }
      /* Open first - never block on audio */
      setOpen(true);
      markAutoOpened();
      root.classList.add("is-nudge");
      window.setTimeout(function () {
        root.classList.remove("is-nudge");
      }, 1400);
      playAppleAlert();
    }

    if (!alreadyAutoOpened()) {
      autoTimer = window.setTimeout(autoOpenChat, DELAY_MS);
    }

    /* Expose for debug / manual re-trigger */
    window.manaWaAutoOpen = autoOpenChat;
    window.manaWaClearAuto = function () {
      try {
        sessionStorage.removeItem(AUTO_KEY);
      } catch (_) {}
      if (autoTimer) window.clearTimeout(autoTimer);
      autoTimer = window.setTimeout(autoOpenChat, DELAY_MS);
    };
  }

  if (document.body) boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();
